/* eslint-disable */
import {toUpper} from 'lodash';

export const getInitial=(name)=> {
  if (!name) {
      return '-';
  }
  const newName=name.trim();
  const splice = newName.split(" ");

  return toUpper(`${splice[0][0]}${typeof splice[1] === 'undefined'
      ? ""
      : splice[1][0]}`);
}

export const stringToHslColor=(str, s, l) =>{
  let hash = 0;
  // for (var i = 0; i < str.length; i++) {
  //   hash = str.charCodeAt(i) + ((hash << 5) - hash);
  // }
  
  // var h = hash % 360;
  if (str.length === 0) return hash; 
                
  for (let i = 0; i < str.length; i++) { 
      let char = str.charCodeAt(i); 
      hash = ((hash << 5) - hash) + char; 
      hash = hash & hash; 
  } 
  return 'hsl('+hash+', '+s+'%, '+l+'%)';
}

export const stripTags = (html , args = ['b', 'i', 'u', 'span', 'strong', 's'])=> {
  // Strip all except basic formatting;
  return html.replace(/<(\/?)(\w+)[^>]*\/?>/g, (_, endMark, tag) => {
    return args.includes(tag) ? '<' + endMark + tag + '>' : '';
  }).replace(/<!--.*?-->/g, '');
}

export const unescapeHTML = (escapedHTML) => {
  return escapedHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
}

export const replaceSpecialChars = (str) => {
  var result;
  if (str !== "") {
     result = str.replace(/\\/g, '\\\\');
     result = str.replace(/\[/g, '\[');
     result = str.replace(/\]/g, '\]');
     result = str.replace(/\*/g, '\*');
    //  result = str.replace(/\n/g, "<br>")
    //  ...
  }
  return result; 
}